import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/global-error.tsx");
